import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/feature/Seo';
import Footer from '../components/feature/Footer';
import { fetchNotFoundPage, type NotFoundPage as NotFoundPageData } from '../services/notFoundPage';

export default function NotFound() {
  const [data, setData] = useState<NotFoundPageData | null>(null);

  useEffect(() => {
    fetchNotFoundPage().then(setData).catch((err) => {
      console.error('Failed to load 404 page data:', err);
    });
  }, []);

  const heading = data?.heading || 'Seite nicht gefunden';
  const description =
    data?.description || 'Die Seite, die du suchst, existiert nicht oder wurde verschoben.';
  const buttonText = data?.buttonText || 'Zur Startseite';
  const buttonLink = data?.buttonLink || '/';

  return (
    <div className="flex min-h-screen flex-col bg-[#FAF8F5]">
      <Seo
        title="Seite nicht gefunden | Gerald Fasching"
        description="Die angefragte Seite existiert nicht. Zurück zur Startseite von gerald-fasching.at."
        noindex
      />
      <main className="flex flex-1 flex-col items-center justify-center px-6 py-24 text-center">
        <p className="mb-4 text-7xl font-bold text-[#8B1538]/20" style={{ fontFamily: 'Lora, serif' }}>404</p>
        <h1 className="mb-4 text-[1.625rem] font-bold leading-snug text-[#1A2B3C] md:text-[1.875rem] lg:text-[2.25rem]" style={{ fontFamily: 'Lora, serif' }}>
          {heading}
        </h1>
        <p className="mb-8 max-w-md text-base text-gray-700 lg:text-lg">
          {description}
        </p>
        <Link
          to={buttonLink}
          className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-[#8B1538] px-7 py-3.5 text-sm font-semibold leading-none text-white shadow-lg shadow-[#8B1538]/25 transition-all hover:bg-[#6B0F2A] hover:shadow-xl active:translate-y-[1px]"
        >
          {buttonText}
        </Link>
      </main>
      <Footer />
    </div>
  );
}
